export default "__VITE_ASSET__CS_OT9Wc__"